import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { Col } from 'react-bootstrap';
import Text from '../Text';
import Card from '../Card';
import FreightValuesContext, { useFreightValues } from './context';
import NegotiatedValuesAttendedEdit from './editing/NegotiatedValuesAttendedEdit';
import HeaderShow from './show/HeaderShow';
import SummaryPayingTransporterCardShow from './show/SummaryPayingTransporterCardShow';
import ReceiveClientCardShow from './show/ReceiveClientCardShow';
import InputValuesShow from './show/InputValuesShow';
import ShipmentDiscountsShow from './show/ShipmentDiscountsShow';
import ShipmentTransferShow from './show/ShipmentTransferShow';
import Button from '../Button';
import NegotiatedValuesShow from './show/NegotiatedValuesShow';
import ShipmentTransferEdit from './editing/ShipmentTransferEdit';

const FreightValuesRef = forwardRef(
  (
    { disableEditing, handleSubmit, onLiberation, showLiberationButton, showEditing, isNational },
    ref,
  ) => {
    const { init, getValues, onChangeShippingCompany, resetData, setInsuranceValueBenner, errors } =
      useFreightValues();
    const [editing, setEditing] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isNegotiatedValuesOpen, setIsNegotiatedValuesOpen] = useState(false);

    useImperativeHandle(ref, () => ({
      getValues,
      init,
      onChangeShippingCompany,
      setInsuranceValueBenner,
      errors,
      finishEditing: () => setEditing(false),
    }));

    function onCancel() {
      resetData();
      setEditing(false);
    }

    function onEdit() {
      setIsNegotiatedValuesOpen(true);
      setEditing(true);
    }

    async function onSubmit() {
      setLoading(true);
      try {
        const submitted = await handleSubmit();
        if (submitted) {
          setEditing(false);
        }
      } finally {
        setLoading(false);
      }
    }

    function onToggleNegotiatedCard() {
      setIsNegotiatedValuesOpen(!isNegotiatedValuesOpen);
    }

    return (
      <Col xs={12}>
        <Card
          header={<Text type="header">Composição de valores de frete</Text>}
          bodyCardPadding="2rem"
          HeaderRightComponent={
            <div className="d-flex align-items-center" style={{ gap: '0.5rem' }}>
              {showEditing && editing ? (
                <>
                  <Button
                    variant="secondary"
                    loading={loading}
                    onClick={onCancel}
                    id="button-cancelar-card-frete"
                  >
                    <Text color="dark" type="regular">
                      Cancelar
                    </Text>
                  </Button>
                  <Button
                    disabled={disableEditing}
                    loading={loading}
                    onClick={onSubmit}
                    variant="primary"
                    id="button-salvar"
                  >
                    <Text color="white" type="regular">
                      Salvar
                    </Text>
                  </Button>
                </>
              ) : (
                <>
                  {showLiberationButton && (
                    <Button onClick={onLiberation} className="py-2">
                      Liberação
                    </Button>
                  )}
                  {showEditing && (
                    <Button
                      disabled={disableEditing}
                      onClick={onEdit}
                      loading={loading}
                      variant="secondary"
                      id="button-editar"
                    >
                      <Text color="dark" type="regular">
                        Editar
                      </Text>
                    </Button>
                  )}
                </>
              )}
            </div>
          }
        >
          <HeaderShow isNational={isNational} />
          <ReceiveClientCardShow />
          <InputValuesShow />
          {editing ? (
            <NegotiatedValuesAttendedEdit
              onChangeIsOpen={onToggleNegotiatedCard}
              defaultIsOpen={isNegotiatedValuesOpen}
            />
          ) : (
            <NegotiatedValuesShow
              onChangeIsOpen={onToggleNegotiatedCard}
              defaultIsOpen={isNegotiatedValuesOpen}
            />
          )}
          <ShipmentDiscountsShow />
          {editing ? (
            <ShipmentTransferEdit isAttended extraFieldButton={false} defaultIsOpen />
          ) : (
            <ShipmentTransferShow />
          )}
          <SummaryPayingTransporterCardShow />
        </Card>
      </Col>
    );
  },
);

export default forwardRef(
  (
    {
      shippingCompany,
      disableEditing,
      handleSubmit,
      disableLiberation,
      onLiberation,
      showLiberationButton,
      showEditing,
      isNational,
    },
    ref,
  ) => {
    return (
      <FreightValuesContext>
        <FreightValuesRef
          ref={ref}
          shippingCompany={shippingCompany}
          disableEditing={disableEditing}
          handleSubmit={handleSubmit}
          disableLiberation={disableLiberation}
          onLiberation={onLiberation}
          showLiberationButton={showLiberationButton}
          showEditing={showEditing}
          isNational={isNational}
        />
      </FreightValuesContext>
    );
  },
);
